import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_TIMECARDS } from "variables/constants";
import EmployeeAttendance from "./index";
import { FaFileCircleCheck } from "react-icons/fa6";

const employeeAttendancesRoutes = [	
	generateCRUDRoutes({
		mainTitle: "My Attendance",
		basePath: "employee-attendance",
		mainComponent: <EmployeeAttendance />,
	    layout: "/console",	   
	    icon: <FaFileCircleCheck className="icon-item" />,
	    subTitle:"My Attendance",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:5,
		moduleId: MODULE_TIMECARDS,
	})
]

export default employeeAttendancesRoutes;